package com.iregained.site.pages

import androidx.compose.runtime.*
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import kotlinx.browser.window
import org.w3c.dom.events.EventListener

@Page("/testimonials")
@Composable
fun TestimonialsPage() {
    val pageSections: List<CmsSection> = listOf(
        CmsSection.TestimonialsBenefitsSection(),
        CmsSection.PatientsRecoveryStoriesSection(),
        CmsSection.TestimonialsCtaSection()
    )

    // 1. Restore the scroll position when the page loads
    LaunchedEffect(Unit) {
        // We use a slight delay (150ms) to give the DOM and animations time to render
        // their heights before attempting to scroll down.
        window.setTimeout({
            val savedScroll = window.sessionStorage.getItem("testimonials_scroll_position")?.toDoubleOrNull()
            if (savedScroll != null && savedScroll > 0) {
                window.scrollTo(0.0, savedScroll)
            }
        }, 150)
    }

    // 2. Continuously track and save the scroll position to sessionStorage
    DisposableEffect(Unit) {
        val scrollListener = EventListener {
            window.sessionStorage.setItem("testimonials_scroll_position", window.scrollY.toString())
        }

        window.addEventListener("scroll", scrollListener)

        // Cleanup listener to prevent memory leaks when navigating away
        onDispose {
            window.removeEventListener("scroll", scrollListener)
        }
    }

    PageLayout{
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}